import { filter, isEmpty, reduce, some } from 'lodash'

export const compareArrays = (arr1, arr2, value) => {
  //arr1 all elements
  //arr2 elements to comparing
  // newElements are elements wihtout some values, thats why we check them by createdAt

  const newElements = filter(arr1, (el) => !el.createdAt) ?? []

  const oldElements = filter(arr1, (el) => el.createdAt) ?? []

  const sameArraysElements = filter(arr1, (el1) => {
    return some(arr2, (el2) => {
      return el1[value] === el2[value]
    })
  })

  const sameArraysElementsValues = sameArraysElements.map(
    (el) => el[value]
  )

  const changedElements = reduce(
    oldElements,
    (res, cur) => {
      if (!sameArraysElementsValues.includes(cur[value])) {
        return [...res, cur]
      }
      return res ?? []
    },
    []
  )
  if (isEmpty(changedElements) && isEmpty(newElements)) {
    return {
      isEqual: true,
      changedElements,
      newElements,
    }
  } else {
    return { isEqual: false, changedElements, newElements }
  }
}
